import { ConfigObj } from '../utils';
import { MediaQuery } from '../utils/';
import Lottie from 'lottie-web';

const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
const defaultOpts = {
  name: 'animation',
  loop: false,
  autoplay: false,
  path: 'data',
  mobilePath: '',
  bottomOffset: 20,
  mobileBottomOffset: -125,
}

export default class LottieAnimation {
  constructor($el, opts) {
    this.$el = $el
    this.options = ConfigObj.merge(defaultOpts, opts)
    this.played = false
    this.isMobile = MediaQuery.create({ maxWidth: 1440 }).matches;
  }

  init() {
    let path = this.options.mobilePath !== '' && this.isMobile ? this.options.mobilePath : this.options.path
    Lottie.loadAnimation({
      name: this.options.name,
      container: this.$el, // the dom element that will contain the animation
      renderer: 'svg',
      loop: this.options.loop,
      autoplay: this.options.autoplay,
      path: path // the path to the animation json
    });

    this.isInRange()

    if (!this.options.autoplay) {
      window.addEventListener('scroll', this.isInRange.bind(this))
    }
  }

  isInRange() {
    let bounding = this.$el.getBoundingClientRect()
    if (!this.played && bounding.bottom <= viewportHeight - (this.isMobile ? this.options.mobileBottomOffset : this.options.bottomOffset)) {
      this.played = true
      Lottie.play(this.options.name)
    } else if (this.played && bounding.top > viewportHeight) {
      this.played = false
      Lottie.stop(this.options.name)
    }
  }
}



// WEBPACK FOOTER //
// ./js/modules/LottieAnimation.js